import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/shared/store'
import { usePartner } from '@/features/auth'
import { AuthLoading } from './AuthLoading'

interface GuestRouteProps {
  children: React.ReactNode
}

export const GuestRoute = ({ children }: GuestRouteProps) => {
  const isAuthInitialized = useAuthStore((s) => s.isAuthInitialized)
  const { partner, isLoading } = usePartner()

  if (!isAuthInitialized || isLoading) {
    return <AuthLoading />
  }

  if (partner) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
